import { useEffect, useState } from "react";

import { REACT_APP_ARPS_BASE_URL } from "../../../utils/urls";
import OperatorDetails from "./OperatorDetails";
import { keys } from "lodash";
import formatShort from "../../../utils/formatShort";
import userimg from "../../../assets/user.png";
import { slice } from "lodash";

export default function RevenueByOprt({
  startDate,
  endDate,
  isVisible,
  setVisible,
}: any) {
  const [revenues, setRevenues] = useState<any>([]);
  const [isLoading, setLoading] = useState(false);
  const [selected, setSelected] = useState();
  const operators: any = {
    "0113": "Samweli Kitomari",
    "0069": "Anna Mzori",
    "0005": "Fatuma Suleiman",
    "0104": "Noela Soka",
    "0006": "Anna Chaulo",
    "0027": "Diana Laizer",
    "0004": "Juliana Sendwa",
    "0048": "Consolata Begina",
    "0112": "Ruth Kulindwa",
  };

  const raw = keys(operators);

  const fetchRevenues = async () => {
    setLoading(true);
    const response = await fetch(
      `${REACT_APP_ARPS_BASE_URL}/revenue/workshop/operator?start=${startDate}&end=${endDate}`
    );
    const data = await response.json();
    const rawData = data.filter((item: any) => raw.includes(item._id));
    setRevenues(rawData);
    setLoading(false);
  };

  useEffect(() => {
    fetchRevenues();
  }, [startDate]);

  const filtered = revenues.filter(
    (revenue: any) =>
      revenue._id !== "Cresencia" &&
      revenue._id !== "Fatuma" &&
      revenue._id !== "Swati"
  );

  filtered.sort(function (a: any, b: any) {
    return b.net - a.net;
  });

  let top = slice(filtered, 0, 5);
  let all = filtered;

  const dummy = [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }];

  if (isLoading) {
    return (
      <>
        {dummy.map((item: any) => (
          <div className="border-t p-2 flex justify-between items-center">
            <div className="flex">
              <div className="h-16 w-16 flex justify-center items-center rounded-full border-4 border-gray-300">
                <img className="h-12 w-12 rounded-full" src={userimg} alt="" />
              </div>
              <div className="flex-col ml-4">
                <div className="font-bold text-gray-800 h-5 w-24 bg-gray-100"></div>
                <div className="text-gray-800">Service Consultant</div>
                <div className="text-gray-500">Toyota HQ</div>
              </div>
            </div>
            <div className="border-l w-24 pl-2 font-bold text-2xl flex justify-center items-center">
              <div className="rounded-sm text-black text-3xl font-bold">
                <div className="w-16 bg-gray-100 h-7 mt-2 rounded-md"></div>
              </div>
            </div>
          </div>
        ))}
      </>
    );
  }

  return (
    <div className="">
      {top.map((consultant: any) => (
        <div className="border-t p-2 flex justify-between items-center">
          <div className="flex">
            <div className="h-16 w-16 flex justify-center items-center rounded-full border-4 border-gray-300">
              <img className="h-12 w-12 rounded-full" src={userimg} alt="" />
            </div>
            <div className="flex-col ml-4">
              <div className="font-bold text-gray-800 ">
                {operators[consultant._id] ?? consultant._id}
              </div>
              <div className="text-gray-800">Service Consultant</div>
              <div className="text-gray-500">
                Revenue: {formatShort(consultant.net)}
              </div>
            </div>
          </div>
          <div className="border-l w-32 pl-2 font-bold text-xl flex justify-center items-center">
            <div className="">
              {consultant.hours_sold.toFixed(2)}
              <div className="text-gray-600 text-sm">Hrs</div>
            </div>
          </div>
        </div>
      ))}
      <OperatorDetails
        isVisible={isVisible}
        setShowDetails={setVisible}
        selected={selected}
        revenues={all}
        operators={operators}
        startDate={startDate}
        endDate={endDate}
      />
    </div>
  );
}
